import { useCookies } from "vue3-cookies";

export default function isUnauth() {
  // if we have VITE_UNAUTH set to true, then always return true
  if (import.meta.env.VITE_UNAUTH === "true") return true;

  const cookies = useCookies().cookies;
  return !cookies.get("x-lacp-secure") || !cookies.get("x-lacp-profile");
}
